import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './transaction-details.reducer';

export const TransactionDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const transactionDetailsEntity = useAppSelector(state => state.transactionDetails?.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="transactionDetailsDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.transactionDetails.detail.title">TransactionDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{transactionDetailsEntity.id}</dd>
          <dt>
            <span id="paymentTransactionId">
              <Translate contentKey="fitengineerBackendV2App.transactionDetails.paymentTransactionId">Payment Transaction Id</Translate>
            </span>
          </dt>
          <dd>{transactionDetailsEntity.paymentTransactionId}</dd>
          <dt>
            <span id="product">
              <Translate contentKey="fitengineerBackendV2App.transactionDetails.product">Product</Translate>
            </span>
          </dt>

          <dd>{transactionDetailsEntity.product}</dd>
          <dt>
            <span id="product">
              {/* <Translate contentKey="fitengineerBackendV2App.transactionDetails.product"> */}
              Amount
              {/* </Translate> */}
            </span>
          </dt>

          <dd>{transactionDetailsEntity.amount}</dd>
          <dt>
            <span id="productName">
              <Translate contentKey="fitengineerBackendV2App.transactionDetails.productName">Product Name</Translate>
            </span>
          </dt>
          <dd>{transactionDetailsEntity.productName}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="fitengineerBackendV2App.transactionDetails.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{transactionDetailsEntity.productId}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.transactionDetails.user">User</Translate>
          </dt>
          <dd>
            {' '}
            <Button tag={Link} to={`/admin/user-management/${transactionDetailsEntity?.user?.login}`} color="link" size="lg">
              {transactionDetailsEntity.user ? transactionDetailsEntity.user.login : ''}
            </Button>
          </dd>
          <dt>
            {/* <Translate contentKey="fitengineerBackendV2App.transactionDetails.user"> */}
            Important User Details
            {/* </Translate> */}
          </dt>
          <dd>
            {' '}
            <Button tag={Link} to={`/important-user-details/${transactionDetailsEntity?.importantUserDetails?.id}`} color="link" size="lg">
              {transactionDetailsEntity.importantUserDetails ? transactionDetailsEntity.importantUserDetails.id : ''}
            </Button>
          </dd>
        </dl>
        <Button tag={Link} to="/transaction-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/transaction-details/${transactionDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TransactionDetailsDetail;
